import { Container } from "@mui/material"

import ScrollToTop from '../../../components/general/ScrollToTop'
function Terms(props: any) {


	return (
		<>
			<ScrollToTop />
			<Container maxWidth="lg">

				<h2>
					Tax to Form Terms of Use
				</h2>

			</Container>
		</>
	)

}

export default Terms